/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'error': {
    viewBox: '0 0 16 16',
    data: `<path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M1,8c0-3.9,3.1-7,7-7c1.8,0,3.3,0.7,4.6,1.7l-9.9,9.9C1.7,11.3,1,9.8,1,8z M8,15c-1.8,0-3.3-0.7-4.6-1.7l9.9-9.9C14.3,4.7,15,6.2,15,8C15,11.9,11.9,15,8,15z"/>`
  }
})
